// apiConfig.js
import axios from 'axios';
import { getAuthToken, removeAuthToken, removeUserData } from '../utils/localStorage';
import { ErrorToast } from '../utils/toast';


const BASE_URL = process.env.REACT_APP_BASEURL;
const AUTH = '/auth/';

// FOR LIVE URL
const API_PATH = 'api';

// FOR LOCAL URL
// const API_PATH = 'workmanagementsystem/public/api';


// -------------------------
// Axios Instances
// -------------------------
const apiConfig = axios.create({
    baseURL: `${BASE_URL}${API_PATH}`,
    maxContentLength: Infinity,
});

const authConfig = axios.create({
    baseURL: `${BASE_URL}${API_PATH}${AUTH}`,
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAuthToken()}`,
    },
});

// -------------------------
// Request Interceptor (Add Source + Token)
// -------------------------
const addSourceAndToken = (config) => {
    const token = getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;

    const defaultSource = "web";

    if (["post"].includes(config.method)) {
        if (config.data instanceof FormData) { //FOR FORMDATA PAYLOAD
            config.data.append("Source", defaultSource);
        } else { //FOR NORMAL PAYLOAD
            config.data = {
                ...config.data,
                Source: defaultSource,
            };
        }
    }

    return config;
};

apiConfig.interceptors.request.use(addSourceAndToken, (error) => Promise.reject(error));
authConfig.interceptors.request.use(addSourceAndToken, (error) => Promise.reject(error));

// -------------------------
//  Response Error Handler
// -------------------------
const handleResponseError = (error, isAuth = false) => {
    const { response } = error;

    if (response) {
        const status = response.status;
        let message = response?.data?.message || "Something went wrong!";

        if (status === 422 && response?.data?.errors) {
            message = Object.values(response.data.errors)[0][0];
        }

        if (isAuth && status === 401) {
            // Special handling for authConfig
            ErrorToast(message || "UnAuthorized");
            removeAuthToken();
            removeUserData();
            setTimeout(() => {
                window.location.href = "/login";
            }, 1000);
        } else {
            // General handling
            ErrorToast(message);
        }
    } else if (error.message === "Network Error") {
        ErrorToast("Network Error");
    }

    return Promise.reject(error.response || error);
};

// -------------------------
// Response Interceptors
// -------------------------
apiConfig.interceptors.response.use((res) => res, (error) => handleResponseError(error));
authConfig.interceptors.response.use((res) => res, (error) => handleResponseError(error, true));

export { apiConfig, authConfig };